import React, { useState, useEffect } from "react";
import { array } from "prop-types";
import keys from "lodash/keys";
import TableButton from "../../atoms/table-button";
import slice from "lodash/slice";

import "./table.m.css";

const limit = 10;
const pagination = 5;

const Table = ({ data, headers }) => {
  const [filteredData, setFilteredData] = useState(data);
  const [selectedIndex, setSelectedIndex] = useState(1);

  useEffect(
    () => {
      filterData(1);
    },
    [data]
  );

  const filterData = index => {
    if (index >= 1 && index <= getLastIndex()) {
      const first = (index - 1) * limit;
      const last = first + limit;
      setSelectedIndex(index);
      setFilteredData(slice(data, first, last));
    } else if (index === 0 || index === getLastIndex() + 1) {
    } else {
      setSelectedIndex(1);
      setFilteredData([]);
    }
  };

  const renderHeaders = () => {
    return (
      <tr>
        {headers.map(headerItem => (
          <th key={headerItem.key} styleName="table-header-item">
            {headerItem.name}
          </th>
        ))}
      </tr>
    );
  };

  const renderRows = () => {
    return filteredData.map((dataItem, dataItemIndex) => {
      const dataItemKeys = keys(dataItem);
      return (
        <tr key={dataItemIndex}>
          {headers.map((headerItem, headerItemIndex) => {
            return dataItemKeys.includes(headerItem.key) ? (
              <td key={`${dataItemIndex}-${headerItemIndex}`} styleName="table-row-item">
                {dataItem[headerItem.key]}
              </td>
            ) : (
              <td key={`${dataItemIndex}-${headerItemIndex}`} styleName="table-row-item" />
            );
          })}
        </tr>
      );
    });
  };

  const getLastIndex = () => {
    return data.length % limit === 0 ? data.length / limit : Math.floor(data.length / limit) + 1;
  };

  const renderDynamicTableNavButtons = () => {
    const dynamicTableButtons = [];
    const lastIndex = getLastIndex();

    for (let i = 1; i <= lastIndex; i++) {
      if (data.length <= pagination * limit) {
        dynamicTableButtons.push(
          <TableButton key={i} onClick={() => filterData(i)} selected={i === selectedIndex}>
            {i}
          </TableButton>
        );
      } else {
        if (i <= pagination && selectedIndex <= pagination) {
          dynamicTableButtons.push(
            <TableButton key={i} onClick={() => filterData(i)} selected={i === selectedIndex}>
              {i}
            </TableButton>
          );
        } else if (i >= lastIndex - pagination + 1 && selectedIndex >= lastIndex - pagination + 1) {
          dynamicTableButtons.push(
            <TableButton key={i} onClick={() => filterData(i)} selected={i === selectedIndex}>
              {i}
            </TableButton>
          );
        } else if (
          selectedIndex > pagination &&
          selectedIndex < lastIndex - pagination + 1 &&
          i >= selectedIndex - Math.floor(pagination / 2) &&
          i <= selectedIndex + Math.floor(pagination / 2)
        ) {
          dynamicTableButtons.push(
            <TableButton key={i} onClick={() => filterData(i)} selected={i === selectedIndex}>
              {i}
            </TableButton>
          );
        }
      }
    }
    return dynamicTableButtons;
  };

  const isPrevDotHidden = () => {
    if (data.length <= pagination * limit) {
      return true;
    }
    return selectedIndex < 1 + pagination;
  };

  const isNextDotHidden = () => {
    if (data.length <= pagination * limit) {
      return true;
    }
    return selectedIndex > getLastIndex() - pagination;
  };

  const renderTableNavButtons = () => {
    const isPrevDisabled = selectedIndex === 1;
    const isNextDisabled = selectedIndex === getLastIndex();

    return (
      <div styleName="nav-buttons">
        <TableButton onClick={() => filterData(1)} disabled={isPrevDisabled}>
          First
        </TableButton>
        <TableButton onClick={() => filterData(selectedIndex - 1)} disabled={isPrevDisabled}>
          Previous
        </TableButton>
        {!isPrevDotHidden() ? <TableButton disabled={true}>...</TableButton> : null}
        {renderDynamicTableNavButtons()}
        {!isNextDotHidden() ? <TableButton disabled={true}>...</TableButton> : null}
        <TableButton onClick={() => filterData(selectedIndex + 1)} disabled={isNextDisabled}>
          Next
        </TableButton>
        <TableButton onClick={() => filterData(getLastIndex())} disabled={isNextDisabled}>
          Last
        </TableButton>
      </div>
    );
  };

  return (
    <div>
      <table styleName="table-container" cellPadding="10" cellSpacing="2">
        <tbody>
          {renderHeaders()}
          {renderRows()}
        </tbody>
      </table>
      {renderTableNavButtons()}
    </div>
  );
};

Table.propTypes = {
  data: array,
  headers: array
};

export default Table;
